import React from 'react'
import '../css/laoding.scss'
const load = [1,1,1,1,1,1,1,1,1,1]
function Loading() {
   
    return (
        <div className={'loading'}>
          <div class='body'>
  <span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </span>
  <div class='base'>
    <span></span>
    <div class='face'></div>
  </div>
</div>
<div class='longfazers'>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
<h1>LOADING</h1>
        </div>
    )
}

export default Loading
